@use "../../../mixins" as *;
@use "../../../variables" as *;

$image-container-height: 150vw;
$image-container-min-height: 77vh;

.detail-container {
  position: absolute;
  top: 0;
  z-index: 1010;
  height: 100vh;
  background-color: $white;

  .image-container {
    position: fixed;

    height: 0;
    width: 100%;

    .close {
      position: absolute;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 2rem;
      height: 2rem;
      top: 1rem;
      right: 1rem;
      z-index: 999;
      background: $white;
      border-radius: 100%;
      border: none;

      > span {
        width: 1rem;
        height: 1rem;
      }
    }

    .page-indicator-container {
      position: absolute;
      display: flex;
      flex-direction: column;
      align-items: center;
      z-index: 1;
      left: 1.5rem;
      // margin is used instead of top: to fix Samsung mobile browser
      margin-top: 60%;

      .page-indicator {
        width: 0.25rem;
        height: 0.25rem;
        background-color: transparent;
        border: 1px solid $grey-light;
        border-radius: 180px;
        margin-top: 0.25rem;
        margin-bottom: 0.25rem;

        &.selected {
          width: 0.5rem;
          height: 0.5rem;
          background-color: $white;
        }
      }
    }
  }

  //Activate to enable scroll snap for chrome mobile
  .snap-dummy {
    scroll-snap-align: start;
  }

  .info-container {
    position: absolute;
    width: 100vw;
    min-height: 100vh;
    background: $white;
    top: $image-container-height;
    padding-top: 0.5rem;

    @media (min-aspect-ratio: 15/24) {
      top: $image-container-min-height;
    }

    .tag-like {
      position: absolute;
      width: 100%;
      top: -3.5rem;

      .tag,
      .like {
        position: absolute;
      }

      .like {
        right: 1.5rem;

        svg {
          width: 1.875rem;
          height: 1.875rem;
        }

        &.fill span {
          fill: $ny-red;
        }
      }
    }
  }
}

.product-not-found-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  background: $white-ter;
  height: 100vh;

  .info-text {
    color: $grey-text;
    text-align: center;
    font-weight: 300;
    font-size: 1rem;
    padding: 4rem 2rem 0;
    line-height: 1.75rem;
  }

  .filter-reset {
    margin-top: 4rem;
  }
}